import React from "react";
import { Box, Card, Typography, Button } from "@bca/ui-library";
import { useRouter } from "next/dist/client/router";

interface SoldVehicleCardProps {
  heading: string;
  headingColor: string;
}

const SoldVehicleCard: React.FunctionComponent<SoldVehicleCardProps> = ({
  heading,
  headingColor,
}) => {
  const router = useRouter();

  return (
    <Card
      width="100%"
      height="auto"
      marginX={0}
      marginY={[3, 7, 0]}
      paddingX={28}
      paddingY={28}
    >
      <Box display="flex" height="100%" flexDirection={["column", "row"]}>
        <Box
          display="flex"
          flexDirection="column"
          flex={1}
          justifyContent="center"
        >
          <Typography color={headingColor} variant="h6" m={0} mb={3}>
            {heading}
          </Typography>
          <Typography variant="body" color="grey-blue" m={0}>
            This vehicle is no longer available.
          </Typography>
        </Box>
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center"
          css={`
            @media screen and (min-width: 320px) and (max-width: 540px) {
              margin-top: 20px;
            }
          `}
          marginTop={{
            mobile: 5,
            tablet: 0,
            desktop: 0,
          }}
        >
          <Button
            variant="secondary"
            text="Find more vehicles"
            width={{
              mobile: "100%",
              tablet: "90%",
              desktop: "70%",
            }}
            onClick={() => {
              router.push("//auctionview.bca.co.uk/Buyer/FacetedSearch");
            }}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default SoldVehicleCard;
